import { endOfToday, subYears } from 'date-fns';
import { z } from 'zod';

export const birthdayDateSchema = z.object({
  birthdayDate: z
    .date({
      required_error: 'errors.input.invalid_date',
      invalid_type_error: 'errors.input.invalid_date',
    })
    .max(subYears(endOfToday(), 18), 'errors.input.invalid_date'),
});

export type TFormValues = z.infer<typeof birthdayDateSchema>;
